import { basicAuth, fetchTokenAuth } from "../standardAuthPatterns";
import { defineProduct, productVariant } from "../types";
import logo from "./logo.svg";

export const dockerHub = defineProduct({
  name: "Docker Hub",
  tagLine: "Container image registry",
  keywords: "dockerhub containers images registry oci repositories tags",
  logo,
  tags: ["engineering"],
  variants: [
    productVariant({
      identifier: "dockerHub",
      authLabel: "Hub API",
      protocol: "http",
      defaultUrlPattern: () => "https://hub\\.docker\\.com/.*",
      auth: (app) =>
        fetchTokenAuth({
          request: {
            url: "https://hub.docker.com/v2/users/login",
            jsonBody: {
              username: app.config.username,
              password: app.secret.personalAccessToken,
            },
          },
          extract: { from: "jsonPath", paths: ["token"] },
          apply: { kind: "header", scheme: "Bearer" },
        }),
      steps: [
        {
          title: "Create a Docker personal access token",
          items: [
            {
              kind: "markdown",
              content:
                "In Docker Hub, create a personal access token and use it in place of your password for API access.",
            },
          ],
        },
        {
          title: "Enter your Docker Hub details",
          items: [
            {
              kind: "input",
              label: "Docker Hub username",
              required: true,
              target: { kind: "configuration", field: "username" },
            },
            {
              kind: "input",
              label: "Personal access token",
              required: true,
              target: { kind: "secrets", field: "personalAccessToken" },
            },
          ],
        },
      ],
      connectionTest: {
        protocol: "http",
        request: () => "https://hub.docker.com/v2/user/",
      },
    }),
    productVariant({
      identifier: "dockerHubRegistry",
      authLabel: "Registry",
      protocol: "http",
      defaultUrlPattern: () => "https://auth\\.docker\\.io/token(?:\\?.*)?$",
      auth: (app) =>
        basicAuth({
          username: app.config.username,
          password: app.secret.personalAccessToken,
        }),
      steps: [
        {
          title: "Create a Docker access token",
          items: [
            {
              kind: "markdown",
              content:
                "Create a [personal access token](https://docs.docker.com/security/access-tokens/personal-access-tokens/) with Read permission, or an [organization access token](https://docs.docker.com/security/access-tokens/organization-access-tokens/) with pull access to the repositories you need. For an organization token, enter the organization name as the username. Attach this connector to steps that pull Docker Hub images, including private base images in Dockerfiles.",
            },
          ],
        },
        {
          title: "Enter your Docker Hub details",
          items: [
            {
              kind: "input",
              label: "Docker Hub username or organization name",
              required: true,
              target: { kind: "configuration", field: "username" },
            },
            {
              kind: "input",
              label: "Access token",
              required: true,
              target: { kind: "secrets", field: "personalAccessToken" },
            },
          ],
        },
      ],
      connectionTest: {
        protocol: "http",
        request: () =>
          "https://auth.docker.io/token?service=registry.docker.io",
      },
    }),
  ],
});
